import { useQuery, useMutation } from "convex/react";
import { api } from "convex/_generated/api";
import { Check, X, Star, UserCheck } from "lucide-react";
import { Button } from "../ui/button";

export function UserVerificationsQueue() {
  const pendingUsers = useQuery(api.moderation.getPendingUserVerifications);
  const approveUser = useMutation(api.moderation.approveUserVerification);
  const rejectUser = useMutation(api.moderation.rejectUserVerification);
  const setTrusted = useMutation(api.moderation.setUserTrusted);

  if (pendingUsers === undefined) {
    return (
      <section>
        <h2 className="font-semibold text-lg text-foreground mb-4 flex items-center gap-2">
          <UserCheck className="w-5 h-5" />
          User Verifications
        </h2>
        <div className="space-y-3">
          {[1, 2].map((i) => (
            <div key={i} className="h-16 bg-secondary/30 rounded-lg animate-pulse" />
          ))}
        </div>
      </section>
    );
  }

  return (
    <section>
      <h2 className="font-semibold text-lg text-foreground mb-4 flex items-center gap-2">
        <UserCheck className="w-5 h-5" />
        User Verifications ({pendingUsers.length})
      </h2>

      {pendingUsers.length === 0 ? (
        <div className="text-center py-8 bg-card rounded-xl border border-border/50">
          <p className="text-muted-foreground">No pending user verifications.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {pendingUsers.map((user) => (
            <div
              key={user._id}
              className="bg-card rounded-xl border border-border/50 p-4 flex items-center justify-between gap-4"
            >
              <div className="flex-1 min-w-0">
                <p className="font-medium text-foreground truncate">
                  {user.name || user.email}
                </p>
                <p className="text-sm text-muted-foreground">{user.email}</p>
                <p className="text-xs text-muted-foreground capitalize mt-0.5">
                  Account type: {user.accountType}
                </p>
                {user.verification?.externalUrl && (
                  <a
                    href={user.verification.externalUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xs text-primary hover:underline mt-1 block"
                  >
                    {user.verification.externalUrl}
                  </a>
                )}
              </div>
              <div className="flex gap-2 flex-shrink-0">
                <Button
                  size="sm"
                  variant="outline"
                  className="text-green-400 hover:text-green-300 hover:bg-green-500/10"
                  title="Approve (mark Verified)"
                  onClick={() => approveUser({ userId: user._id })}
                >
                  <Check className="w-4 h-4" />
                </Button>
                <Button
                  size="sm"
                  variant="outline"
                  className="text-yellow-400 hover:text-yellow-300 hover:bg-yellow-500/10"
                  title="Mark as Trusted"
                  onClick={() => setTrusted({ userId: user._id })}
                >
                  <Star className="w-4 h-4" />
                </Button>
                <Button
                  size="sm"
                  variant="outline"
                  className="text-red-400 hover:text-red-300 hover:bg-red-500/10"
                  title="Reject"
                  onClick={() => rejectUser({ userId: user._id })}
                >
                  <X className="w-4 h-4" />
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
